import { MARKDOWN_INPUT_ELEMENT } from "@/editor/MarkdownInputPlugin/consts";
import { IQuestionItem } from "../models";
import { SubmitFieldValues } from "./types";
import { v4 } from "uuid";
import { DefinedValueSet } from "@/services/content/content-client";
import { IMarkdownInputElement } from "@/editor/MarkdownInputPlugin/MarkdownInputElement";

function buildValueSet(): DefinedValueSet {
  return {
    resourceType: "ValueSet",
    url: "urn:uuid:" + v4(),
    compose: {
      include: [
        { system: "http://snomed.info/sct" },
        { system: "http://tiro.health/fhir/CodeSystem/auto-generated" },
      ],
    },
  };
}

export function buildQuestion(values: SubmitFieldValues): IQuestionItem {
  const element: IMarkdownInputElement = {
    type: MARKDOWN_INPUT_ELEMENT,
    name: "markdown",
    children: [{ text: "" }],
    valueSet: buildValueSet(),
  };
  return {
    code: {
      text: values.code?.display,
      coding: [values.code],
    },
    orientation: values.orientation,
    mode: "data-entry",
    answer: [element],
  };
}
